  window.initPlans ?? (() => {
    window.initPlans = (section_id) => {

        const plansSliderSection = document.querySelector(`section#shopify-section-${section_id} .careline-25-plans`);

        const swiperElements = plansSliderSection.querySelectorAll(
            '.swiper'
        );

        swiperElements.forEach(swiperElement => {
            
            const swiper = new Swiper(swiperElement, {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                navigation: {
                    prevEl: swiperElement.querySelector(
                        '.swiper-button-prev'
                    ),
                    nextEl: swiperElement.querySelector(
                        '.swiper-button-next'
                    )
                },
                pagination: {
                    el: swiperElement.querySelector(
                        '.swiper-pagination'
                    ),
                clickable: true
                }
            });
        });

    }
  
})();
